export enum ErknmKnmDocumentTypeCodesEnum {
  TYPE_0 = 'TYPE_0',
  TYPE_I = 'TYPE_I',
  TYPE_II = 'TYPE_II',
  TYPE_III = 'TYPE_III',
  TYPE_IV = 'TYPE_IV',
  TYPE_V = 'TYPE_V',
  TYPE_VI = 'TYPE_VI',
  TYPE_VII = 'TYPE_VII',
  TYPE_VIII = 'TYPE_VIII',
  TYPE_IX = 'TYPE_IX',
  TYPE_X = 'TYPE_X',
  TYPE_XI = 'TYPE_XI',
  TYPE_XII = 'TYPE_XII',
  TYPE_XIII = 'TYPE_XIII',
  TYPE_LV = 'TYPE_LV',
  WEB_0 = 'WEB_0',
  VP_VI = 'VP_VI',
  VP_0 = 'VP_0',
  VP_I = 'VP_I',
  VP_II = 'VP_II',
  VP_III = 'VP_III',
  VP_IV = 'VP_IV',
  VP_V = 'VP_V',
  PP_0 = 'PP_0',
  PP_I = 'PP_I',
  PP_II = 'PP_II',
  PP_III = 'PP_III',
  PP_IV = 'PP_IV',
  PP_V = 'PP_V',
  PP_VI = 'PP_VI',
  PP_VII = 'PP_VII',
  PP_VIII = 'PP_VIII',
  PP_IX = 'PP_IX',
  PP_X = 'PP_X',
  PP_XI = 'PP_XI',
  PP_XII = 'PP_XII',
  PP_XIII = 'PP_XIII',
  PP_XV = 'PP_XV',
  PM_0 = 'PM_0',
  PM_I = 'PM_I',
  MZ_0 = 'MZ_0',
  AP_0 = 'AP_0',
  AP_I = 'AP_I',
  AP_II = 'AP_II',
  AP_III = 'AP_III',
  AP_IV = 'AP_IV',
  AP_V = 'AP_V',
  AP_VI = 'AP_VI',
  AP_VII = 'AP_VII',
}
